/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type WebAppTeamsQueryVariables = {
    orgRelayId: string;
    myCalendarIds: Array<string>;
};
export type WebAppTeamsQueryResponse = {
    readonly viewer: {
        readonly id: string;
        readonly user: {
            readonly id: string;
            readonly orgs: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly userTeams: {
                            readonly list?: ReadonlyArray<{
                                readonly teamName: string;
                                readonly createdBy: {
                                    readonly value: string | null;
                                };
                                readonly invitedMembers: ReadonlyArray<{
                                    readonly person: {
                                        readonly profile: {
                                            readonly givenName: string | null;
                                            readonly familyName: string | null;
                                        } | null;
                                        readonly primaryCalendarId: string;
                                        readonly " $fragmentRefs": FragmentRefs<"AvatarPerson_orgPerson">;
                                    };
                                }>;
                                readonly teamMembers: ReadonlyArray<{
                                    readonly person: {
                                        readonly profile: {
                                            readonly givenName: string | null;
                                            readonly familyName: string | null;
                                        } | null;
                                        readonly primaryCalendarId: string;
                                        readonly " $fragmentRefs": FragmentRefs<"AvatarPerson_orgPerson">;
                                    };
                                }>;
                            }> | undefined;
                        };
                        readonly " $fragmentRefs": FragmentRefs<"TeamJoinCreate_org">;
                    } | null;
                } | null> | null;
            };
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"TeamJoinCreate_viewer">;
    };
};
export type WebAppTeamsQuery = {
    readonly response: WebAppTeamsQueryResponse;
    readonly variables: WebAppTeamsQueryVariables;
};



/*
query WebAppTeamsQuery(
  $orgRelayId: ID!
  $myCalendarIds: [String!]!
) {
  viewer {
    ...TeamJoinCreate_viewer_2rslMm
    id
    user {
      id
      orgs(first: 1000000) {
        edges {
          node {
            ...TeamJoinCreate_org
            userTeams {
              __typename
              ... on TeamList {
                list {
                  teamName
                  createdBy {
                    value
                    id
                  }
                  invitedMembers {
                    person {
                      ...AvatarPerson_orgPerson
                      profile {
                        givenName
                        familyName
                      }
                      primaryCalendarId
                      id
                    }
                  }
                  teamMembers {
                    person {
                      ...AvatarPerson_orgPerson
                      profile {
                        givenName
                        familyName
                      }
                      primaryCalendarId
                      id
                    }
                  }
                  id
                }
              }
            }
            id
          }
        }
      }
    }
  }
}

fragment AvatarPerson_org on Org {
  id
}

fragment AvatarPerson_orgPerson on OrgPerson {
  __typename
  id
  primaryCalendarId
  isYou
  userId
  profile {
    givenName
    familyName
    externalImageUrl
  }
}

fragment AvatarRowNew_org on Org {
  ...AvatarPerson_org
}

fragment TeamJoinCreate_org on Org {
  ...AvatarRowNew_org
  ...TeamSettingsSearch_org
  ...TeamSearchInputRenderer_org
  id
  primaryOrgCalendar
  orgPersonForUserErrorable {
    __typename
    ... on OrgPerson {
      personId
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  primaryTeam {
    __typename
    ... on Team {
      teamId
      teamName
    }
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  billingGroups {
    __typename
    ... on BillingGroupList {
      list {
        id
        name
        syncSources {
          type
          value
          id
        }
        subscription {
          __typename
          ... on SubscriptionDetails {
            subscription {
              id
              productType
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  userTeams {
    __typename
    ... on TeamList {
      list {
        id
        teamId
        teamName
        createdBy {
          value
          id
        }
        teamCalendarId
        settings {
          __typename
          ... on TeamSettings {
            manageTeamCalendar
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
        userSettings {
          __typename
          ... on TeamUserSettings {
            useTeamCalendar
          }
          ... on Node {
            __isNode: __typename
            id
          }
        }
        teamMembers {
          person {
            ...AvatarPerson_orgPerson
            personId
            primaryCalendarId
            isYou
            profile {
              givenName
              familyName
            }
            id
          }
        }
        invitedMembers {
          person {
            ...AvatarPerson_orgPerson
            personId
            primaryCalendarId
            isYou
            profile {
              givenName
              familyName
            }
            id
          }
        }
      }
    }
  }
  suggestedTeams {
    __typename
    ... on SuggestedTeamList {
      list {
        team {
          id
          teamId
          teamName
          createdBy {
            value
            id
          }
          teamMembers {
            person {
              ...AvatarPerson_orgPerson
              personId
              primaryCalendarId
              isYou
              profile {
                givenName
                familyName
              }
              id
            }
          }
          invitedMembers {
            person {
              ...AvatarPerson_orgPerson
              personId
              primaryCalendarId
              isYou
              profile {
                givenName
                familyName
              }
              id
            }
          }
        }
        reasons {
          type
          value
        }
        score
      }
    }
  }
}

fragment TeamJoinCreate_viewer_2rslMm on Viewer {
  ...TeamSettingsSearch_viewer_YNSM7
  user {
    id
  }
  id
  teamQueryResultErrorable(query: "", orgRelayId: $orgRelayId, excludeMyTeams: true) {
    __typename
    ... on TeamQueryResult {
      query
      teams {
        teamName
        teamId
        teamRoleAndPersonIds {
          role
          personId
        }
        id
      }
      teamMembers {
        role
        person {
          ...AvatarPerson_orgPerson
          personId
          primaryCalendarId
          isYou
          profile {
            givenName
            familyName
          }
          id
        }
      }
    }
  }
}

fragment TeamSearchInputRenderer_org on Org {
  id
}

fragment TeamSettingsSearch_org on Org {
  ...TeamSettingsTeammate_org
  id
  primaryOrgCalendar
  workingGroups(first: 1000000) {
    edges {
      node {
        calendarIds
        id
      }
    }
  }
}

fragment TeamSettingsSearch_viewer_YNSM7 on Viewer {
  orgPersonQueryResultErrorable(query: "", orgRelayId: $orgRelayId, excludeCalendars: $myCalendarIds) {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on OrgPersonQueryResult {
      query
      persons {
        ...AvatarPerson_orgPerson
        userId
        personId
        primaryCalendarId
        calendarAliases
        redirectPersonId
        isYou
        profile {
          givenName
          familyName
          externalImageUrl
        }
        id
      }
    }
  }
}

fragment TeamSettingsTeammate_org on Org {
  ...AvatarPerson_org
  id
  primaryOrgEmail
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "myCalendarIds"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v3 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamName",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "givenName",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "familyName",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryCalendarId",
        "storageKey": null
    } as any, v9 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgPerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                        (v6 /*: any*/),
                        (v7 /*: any*/)
                    ],
                    "storageKey": null
                },
                (v8 /*: any*/),
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AvatarPerson_orgPerson"
                }
            ],
            "storageKey": null
        } as any
    ], v10 = {
        "kind": "Variable",
        "name": "orgRelayId",
        "variableName": "orgRelayId"
    } as any, v11 = {
        "kind": "Literal",
        "name": "query",
        "value": ""
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v15 = {
        "kind": "InlineFragment",
        "selections": [
            (v13 /*: any*/),
            (v14 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "query",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            (v6 /*: any*/),
            (v7 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v21 = {
        "kind": "InlineFragment",
        "selections": [
            (v2 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v22 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
    } as any, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v24 = {
        "kind": "InlineFragment",
        "selections": [
            (v14 /*: any*/),
            (v13 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v25 = {
        "alias": null,
        "args": null,
        "concreteType": "Urn",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            (v5 /*: any*/),
            (v2 /*: any*/)
        ],
        "storageKey": null
    } as any, v26 = {
        "alias": null,
        "args": null,
        "concreteType": "OrgPerson",
        "kind": "LinkedField",
        "name": "person",
        "plural": false,
        "selections": [
            (v12 /*: any*/),
            (v2 /*: any*/),
            (v8 /*: any*/),
            (v17 /*: any*/),
            (v18 /*: any*/),
            (v19 /*: any*/),
            (v20 /*: any*/)
        ],
        "storageKey": null
    } as any, v27 = [
        (v26 /*: any*/)
    ], v28 = {
        "alias": null,
        "args": null,
        "concreteType": "TeamMember",
        "kind": "LinkedField",
        "name": "teamMembers",
        "plural": true,
        "selections": (v27 /*: any*/),
        "storageKey": null
    } as any, v29 = {
        "alias": null,
        "args": null,
        "concreteType": "TeamMember",
        "kind": "LinkedField",
        "name": "invitedMembers",
        "plural": true,
        "selections": (v27 /*: any*/),
        "storageKey": null
    } as any, v30 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "WebAppTeamsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "userTeams",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Team",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v4 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Urn",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "createdBy",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v5 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TeamMember",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "invitedMembers",
                                                                                    "plural": true,
                                                                                    "selections": (v9 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "TeamMember",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "teamMembers",
                                                                                    "plural": true,
                                                                                    "selections": (v9 /*: any*/),
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "TeamList",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "args": null,
                                                            "kind": "FragmentSpread",
                                                            "name": "TeamJoinCreate_org"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "myCalendarIds",
                                    "variableName": "myCalendarIds"
                                },
                                (v10 /*: any*/)
                            ],
                            "kind": "FragmentSpread",
                            "name": "TeamJoinCreate_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "WebAppTeamsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "excludeCalendars",
                                    "variableName": "myCalendarIds"
                                },
                                (v10 /*: any*/),
                                (v11 /*: any*/)
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "orgPersonQueryResultErrorable",
                            "plural": false,
                            "selections": [
                                (v12 /*: any*/),
                                (v15 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        (v16 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgPerson",
                                            "kind": "LinkedField",
                                            "name": "persons",
                                            "plural": true,
                                            "selections": [
                                                (v12 /*: any*/),
                                                (v2 /*: any*/),
                                                (v8 /*: any*/),
                                                (v17 /*: any*/),
                                                (v18 /*: any*/),
                                                (v19 /*: any*/),
                                                (v20 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "calendarAliases",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "redirectPersonId",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "OrgPersonQueryResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": (v3 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgEmail",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgCalendar",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": (v3 /*: any*/),
                                                            "concreteType": "WorkingGroupConnection",
                                                            "kind": "LinkedField",
                                                            "name": "workingGroups",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "WorkingGroupEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "WorkingGroup",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "calendarIds",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v2 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "workingGroups(first:1000000)"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "orgPersonForUserErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v12 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v20 /*: any*/)
                                                                    ],
                                                                    "type": "OrgPerson",
                                                                    "abstractKey": null
                                                                },
                                                                (v21 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "primaryTeam",
                                                            "plural": false,
                                                            "selections": [
                                                                (v12 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v22 /*: any*/),
                                                                        (v4 /*: any*/)
                                                                    ],
                                                                    "type": "Team",
                                                                    "abstractKey": null
                                                                },
                                                                (v15 /*: any*/),
                                                                (v21 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "billingGroups",
                                                            "plural": false,
                                                            "selections": [
                                                                (v12 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "BillingGroup",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "name",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Urn",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "syncSources",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        (v23 /*: any*/),
                                                                                        (v5 /*: any*/),
                                                                                        (v2 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "subscription",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v12 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "PaymentSubscription",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "subscription",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        (v2 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "productType",
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "SubscriptionDetails",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v24 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "BillingGroupList",
                                                                    "abstractKey": null
                                                                },
                                                                (v24 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "userTeams",
                                                            "plural": false,
                                                            "selections": [
                                                                (v12 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Team",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v2 /*: any*/),
                                                                                (v22 /*: any*/),
                                                                                (v4 /*: any*/),
                                                                                (v25 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "teamCalendarId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "settings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v12 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "manageTeamCalendar",
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "TeamSettings",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v21 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "userSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v12 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "useTeamCalendar",
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "TeamUserSettings",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v21 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                (v28 /*: any*/),
                                                                                (v29 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "TeamList",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "suggestedTeams",
                                                            "plural": false,
                                                            "selections": [
                                                                (v12 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "SuggestedTeam",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Team",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "team",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v2 /*: any*/),
                                                                                        (v22 /*: any*/),
                                                                                        (v4 /*: any*/),
                                                                                        (v25 /*: any*/),
                                                                                        (v28 /*: any*/),
                                                                                        (v29 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "SuggestedTeamReason",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "reasons",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        (v23 /*: any*/),
                                                                                        (v5 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "score",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SuggestedTeamList",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                }
                            ],
                            "storageKey": null
                        },
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "excludeMyTeams",
                                    "value": true
                                },
                                (v10 /*: any*/),
                                (v11 /*: any*/)
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "teamQueryResultErrorable",
                            "plural": false,
                            "selections": [
                                (v12 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        (v16 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Team",
                                            "kind": "LinkedField",
                                            "name": "teams",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v22 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "TeamRoleAndPersonId",
                                                    "kind": "LinkedField",
                                                    "name": "teamRoleAndPersonIds",
                                                    "plural": true,
                                                    "selections": [
                                                        (v30 /*: any*/),
                                                        (v20 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v2 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "TeamMember",
                                            "kind": "LinkedField",
                                            "name": "teamMembers",
                                            "plural": true,
                                            "selections": [
                                                (v30 /*: any*/),
                                                (v26 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "TeamQueryResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "857da9917f928e967663642252fd84c2",
            "id": null,
            "metadata": {},
            "name": "WebAppTeamsQuery",
            "operationKind": "query",
            "text": "query WebAppTeamsQuery(\n  $orgRelayId: ID!\n  $myCalendarIds: [String!]!\n) {\n  viewer {\n    ...TeamJoinCreate_viewer_2rslMm\n    id\n    user {\n      id\n      orgs(first: 1000000) {\n        edges {\n          node {\n            ...TeamJoinCreate_org\n            userTeams {\n              __typename\n              ... on TeamList {\n                list {\n                  teamName\n                  createdBy {\n                    value\n                    id\n                  }\n                  invitedMembers {\n                    person {\n                      ...AvatarPerson_orgPerson\n                      profile {\n                        givenName\n                        familyName\n                      }\n                      primaryCalendarId\n                      id\n                    }\n                  }\n                  teamMembers {\n                    person {\n                      ...AvatarPerson_orgPerson\n                      profile {\n                        givenName\n                        familyName\n                      }\n                      primaryCalendarId\n                      id\n                    }\n                  }\n                  id\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment AvatarPerson_org on Org {\n  id\n}\n\nfragment AvatarPerson_orgPerson on OrgPerson {\n  __typename\n  id\n  primaryCalendarId\n  isYou\n  userId\n  profile {\n    givenName\n    familyName\n    externalImageUrl\n  }\n}\n\nfragment AvatarRowNew_org on Org {\n  ...AvatarPerson_org\n}\n\nfragment TeamJoinCreate_org on Org {\n  ...AvatarRowNew_org\n  ...TeamSettingsSearch_org\n  ...TeamSearchInputRenderer_org\n  id\n  primaryOrgCalendar\n  orgPersonForUserErrorable {\n    __typename\n    ... on OrgPerson {\n      personId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  primaryTeam {\n    __typename\n    ... on Team {\n      teamId\n      teamName\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  billingGroups {\n    __typename\n    ... on BillingGroupList {\n      list {\n        id\n        name\n        syncSources {\n          type\n          value\n          id\n        }\n        subscription {\n          __typename\n          ... on SubscriptionDetails {\n            subscription {\n              id\n              productType\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  userTeams {\n    __typename\n    ... on TeamList {\n      list {\n        id\n        teamId\n        teamName\n        createdBy {\n          value\n          id\n        }\n        teamCalendarId\n        settings {\n          __typename\n          ... on TeamSettings {\n            manageTeamCalendar\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        userSettings {\n          __typename\n          ... on TeamUserSettings {\n            useTeamCalendar\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        teamMembers {\n          person {\n            ...AvatarPerson_orgPerson\n            personId\n            primaryCalendarId\n            isYou\n            profile {\n              givenName\n              familyName\n            }\n            id\n          }\n        }\n        invitedMembers {\n          person {\n            ...AvatarPerson_orgPerson\n            personId\n            primaryCalendarId\n            isYou\n            profile {\n              givenName\n              familyName\n            }\n            id\n          }\n        }\n      }\n    }\n  }\n  suggestedTeams {\n    __typename\n    ... on SuggestedTeamList {\n      list {\n        team {\n          id\n          teamId\n          teamName\n          createdBy {\n            value\n            id\n          }\n          teamMembers {\n            person {\n              ...AvatarPerson_orgPerson\n              personId\n              primaryCalendarId\n              isYou\n              profile {\n                givenName\n                familyName\n              }\n              id\n            }\n          }\n          invitedMembers {\n            person {\n              ...AvatarPerson_orgPerson\n              personId\n              primaryCalendarId\n              isYou\n              profile {\n                givenName\n                familyName\n              }\n              id\n            }\n          }\n        }\n        reasons {\n          type\n          value\n        }\n        score\n      }\n    }\n  }\n}\n\nfragment TeamJoinCreate_viewer_2rslMm on Viewer {\n  ...TeamSettingsSearch_viewer_YNSM7\n  user {\n    id\n  }\n  id\n  teamQueryResultErrorable(query: \"\", orgRelayId: $orgRelayId, excludeMyTeams: true) {\n    __typename\n    ... on TeamQueryResult {\n      query\n      teams {\n        teamName\n        teamId\n        teamRoleAndPersonIds {\n          role\n          personId\n        }\n        id\n      }\n      teamMembers {\n        role\n        person {\n          ...AvatarPerson_orgPerson\n          personId\n          primaryCalendarId\n          isYou\n          profile {\n            givenName\n            familyName\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment TeamSearchInputRenderer_org on Org {\n  id\n}\n\nfragment TeamSettingsSearch_org on Org {\n  ...TeamSettingsTeammate_org\n  id\n  primaryOrgCalendar\n  workingGroups(first: 1000000) {\n    edges {\n      node {\n        calendarIds\n        id\n      }\n    }\n  }\n}\n\nfragment TeamSettingsSearch_viewer_YNSM7 on Viewer {\n  orgPersonQueryResultErrorable(query: \"\", orgRelayId: $orgRelayId, excludeCalendars: $myCalendarIds) {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on OrgPersonQueryResult {\n      query\n      persons {\n        ...AvatarPerson_orgPerson\n        userId\n        personId\n        primaryCalendarId\n        calendarAliases\n        redirectPersonId\n        isYou\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment TeamSettingsTeammate_org on Org {\n  ...AvatarPerson_org\n  id\n  primaryOrgEmail\n}\n"
        }
    } as any;
})();
(node as any).hash = '07212cc1bcbc7c448008b7012a4428b6';
export default node;
